"use client";

import Script from "next/script";

// Elfsight Instagram Feed | Aluume Wellness (embed code from the website Figma).
// platform.js scans the DOM for `.elfsight-app-<id>` containers and mounts the
// widget. `data-elfsight-app-lazy` + next/script `lazyOnload` keep it off the
// booking hot path — it only loads once the page is idle / scrolled near.
const ELFSIGHT_APP_ID = "9756a3c5-08aa-42b0-9541-cf8331e0259d";

export function ElfsightInstagram() {
  return (
    <>
      <Script src="https://static.elfsight.com/platform/platform.js" strategy="lazyOnload" />
      <div className={`elfsight-app-${ELFSIGHT_APP_ID}`} data-elfsight-app-lazy />
    </>
  );
}
